/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.We = NO -->*/
/*Allow for use of "We" in sensitive topics like pricing and security -->*/
/*<!-- vale Google.We = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Business tier pricing", description = "Learn about Hightouch's Business tier pricing, including platform fees, consumption-based pricing, and feature add-ons.", lastUpdatedDate = new Date(1780272000000), keywords = "enterprise pricing, enterprise plan, business tier pricing";
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Business tier pricing",
        description: "Learn about Hightouch's Business tier pricing, including platform fees, consumption-based pricing, and feature add-ons.",
        lastUpdatedDate: "Mon Jun 01 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "SOC 2 report",
          "depth": 0,
          "id": "soc-2-report"
        }, {
          "value": "Active syncs",
          "depth": 0,
          "id": "active-syncs"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      ul: "ul",
      li: "li",
      strong: "strong",
      a: "a",
      h2: "h2"
    }, _provideComponents(), props.components), {PylonLink} = _components;
    if (!PylonLink) _missingMdxReference("PylonLink", true);
    return _jsxs(_Fragment, {
      children: ["\n", "\n", _jsx(_components.p, {
        children: "Hightouch's Business tier pricing varies depending on your use case and required features.\nIt typically includes:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["A ", _jsx(_components.strong, {
            children: "platform fee"
          }), ", which could include consumption-based pricing based on ", _jsx(_components.a, {
            href: "https://hightouch.com/docs/pricing/bt-pricing#active-syncs",
            children: "active syncs"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["Optional ", _jsx(_components.strong, {
            children: "feature add-ons"
          }), ", such as ", _jsx(_components.a, {
            href: "/customer-studio/overview",
            children: "Customer Studio"
          }), " features or the ", _jsx(_components.a, {
            href: "/destinations/personalization-api",
            children: "Personalization API"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "This allows us to create a plan that fits your specific feature usage and consumption needs."
      }), "\n", _jsxs(_components.p, {
        children: ["For the complete list of features included in Business tier packages, please visit our ", _jsx(_components.a, {
          href: "https://hightouch.com/pricing",
          children: "pricing page"
        }), ".\nDon't hesitate to ", _jsx(PylonLink, {
          pylonText: "Hi, I'm interested in learning more about the Business tier plan.",
          linkText: "get in touch"
        }), " to receive a quote or discuss whether the Business tier is a good fit for you."]
      }), "\n", "\n", _jsx(_components.h2, {
        id: "soc-2-report",
        children: "SOC 2 report"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are an existing Hightouch Business Tier customer, you can request a copy of our full SOC 2 report at the ", _jsx(_components.a, {
          href: "https://trust.hightouch.com/",
          children: "Hightouch Trust Center"
        }), ".\nIf you are not yet a Business Tier customer but are considering buying Business Tier, we can provide you the report under NDA."]
      }), "\n", _jsx(_components.h2, {
        id: "active-syncs",
        children: "Active syncs"
      }), "\n", _jsxs(_components.p, {
        children: ["An ", _jsx(_components.strong, {
          children: "active sync"
        }), " is any sync that has run at least once in the ", _jsx(_components.strong, {
          children: "previous calendar month"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "This includes syncs that are later deleted or disabled—if a sync ran successfully during that month, it is still counted as active. At the start of each new calendar month, the active sync count resets."
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
